import React from 'react';
import './ProjectsCheckboxPanel.scss';
import {ReactComponent as UploadSvg} from '../../../../assets/icons/upload2.svg';
import {ReactComponent as TrashSvg} from '../../../../assets/icons/trash.svg';
import CheckboxMUI from '../../../../shared/CheckboxMUI';
import {hasPermission} from '../../../../helpers/functions';
import {useTranslation} from 'react-i18next';
import {IconButtonMUI} from '../../../../shared';

const ProjectsCheckboxPanel = ({
  handleCheckAll,
  isCheckAll,
  checkedItems,
  deleteReportMultiple,
  type,
  permissionTrash,
  permissionDownload,
  permissions,
  reportsDownload
}) => {
  const {t} = useTranslation();

  const partialPermission =
    hasPermission(permissionDownload, permissions) || hasPermission(permissionTrash, permissions);

  return (
    <>
      {partialPermission ? (
        <div className={'projects-checkbox-panel'}>
          <div className='projects-checkbox-panel__check'>
            <CheckboxMUI label={t('ProjectsCheckboxPanel.all')} onChange={handleCheckAll} checked={isCheckAll} />
          </div>
          <div className={`projects-checkbox-panel__icons${checkedItems.length ? ' checked' : ''}`}>
            {hasPermission(permissionDownload, permissions) && (
              <div
                className='projects-checkbox-panel__download'
                onClick={() => {
                  reportsDownload(type);
                }}
              >
                <IconButtonMUI color={'inherit'} title={t('ProjectsReports.common.Download')}>
                  <UploadSvg />
                </IconButtonMUI>
              </div>
            )}
            {hasPermission(permissionTrash, permissions) && (
              <div className='projects-checkbox-panel__delete' onClick={() => deleteReportMultiple(type)}>
                <IconButtonMUI color={'inherit'} title={t('ProjectsReports.common.trash')}>
                  <TrashSvg />
                </IconButtonMUI>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ProjectsCheckboxPanel;
